import { Sparkles } from "lucide-react";

const STARTERS = {
  cpg: [
    "What should I say in my first email to a farm shop buyer?",
    "How do I plan a sampling day that actually turns into sales?",
    "What should a small food or drink brand post on Instagram each week?",
  ],
  hospitality: [
    "How do I fill our quiet midweek nights without discounting?",
    "How do I get more Google reviews from happy customers?",
    "When should I start promoting Christmas bookings, and how?",
  ],
  both: [
    "What should my marketing focus on for the next 90 days?",
    "How do I get local press to notice my business?",
    "How do I build an email list from scratch?",
  ],
};

export const StarterQuestions = ({ audience, onPick }) => (
  <div className="mb-8" data-testid="ask-starters">
    <p className="flex items-center gap-1.5 text-xs font-mono uppercase text-muted-foreground mb-3"><Sparkles className="h-3.5 w-3.5 text-pinkb" />Not sure where to start? Tap one</p>
    <div className="flex flex-wrap gap-2">
      {(STARTERS[audience] || STARTERS.both).map((q, i) => (
        <button key={q} type="button" onClick={() => onPick(q)} data-testid={`ask-starter-${i}`}
          className="rounded-full border-2 border-border bg-white px-4 py-2 text-left text-sm text-navy transition-colors hover:border-pinkb/60 hover:bg-pinkb/5">{q}</button>
      ))}
    </div>
  </div>
);
